const { appApiUrl } = require('./api-url');

async function estimatePricingDomain (domain) {
  const response = await fetch(`${appApiUrl}/api/pricing/estimate`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ domain })
  });
  const responseBody = await response.text();
  let result;

  try {
    result = JSON.parse(responseBody);
  } catch {
    throw new Error(response.ok
      ? 'The estimate service returned an invalid response.'
      : 'Unable to estimate this domain right now. Please try again.');
  }

  if (!response.ok) {
    throw new Error(result.error || 'Unable to estimate this domain');
  }

  return result;
}

module.exports = { estimatePricingDomain };
